/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const accessLevel = currentUser?.access ?? 'user';
  /** user 仅可查看；非 user 可维护用户表与产品表 */
  const canMutateBusiness = Boolean(currentUser && accessLevel !== 'user');
  return {
    canAdmin: currentUser && accessLevel === 'admin',
    canManageUsers: canMutateBusiness,
    canManageProducts: canMutateBusiness,
  };
}
